import { Box, Step, StepLabel, Stepper, StepConnector, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CreatePaymentLinkStepperProps, StepIconProps } from "../../payment.types";
import { ActiveStepIcon, CompletedStepIcon, UpComingStepIcon } from "../../../../assets/icons/MUI/PaymentIcons";

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-root": {
    marginLeft: 12,
    height: "32px",
  },

  "&.Mui-active, &.Mui-completed": {
    "& .MuiStepConnector-line": {
      borderColor: "#106048",
      height: "32px",
      width: "2px",
    },
  },
  "& .MuiStepConnector-line": {
    borderColor: "#E4E7EC",
  },
}));

const CreatePaymentLinkStepper = ({ activeStep, setActiveStep }: CreatePaymentLinkStepperProps) => {
  const { t } = useTranslation();
  const steps = [
    {
      title: t("pages.payment.createPaymentLink.paymentDetails"),
      description: t("pages.payment.createPaymentLink.paymentInstructions"),
      value: "paymentDetails",
    },
    {
      title: t("pages.payment.createPaymentLink.selectRecipient"),
      description: t("pages.payment.createPaymentLink.companyDetails"),
      value: "selectRecipients",
    },
    {
      title: t("pages.payment.createPaymentLink.registrationFormFields"),
      description: t("pages.payment.createPaymentLink.activateInput"),
      value: "registerForm",
    },
    {
      title: t("pages.payment.createPaymentLink.reviewPayment"),
      description: t("pages.payment.createPaymentLink.reviewPaymentDetails"),
      value: "reviewPayment",
    },
  ];

  const activeStepIndex = steps.map((step) => step.value).indexOf(activeStep);

  const StepIcon = ({ completed, active, upcoming }: StepIconProps) => {
    if (completed) return <CompletedStepIcon />;
    if (active) return <ActiveStepIcon />;
    if (upcoming) return <UpComingStepIcon />;
    return <UpComingStepIcon />;
  };

  return (
    <Stepper
      sx={{ height: "fit-content" }}
      activeStep={activeStepIndex}
      orientation="vertical"
      connector={<CustomStepConnector />}
    >
      {steps.map(({ title, description }, idx) => (
        <Step key={idx} completed={idx < activeStepIndex}>
          <StepLabel
            StepIconComponent={() =>
              StepIcon({
                completed: idx < activeStepIndex,
                active: idx === activeStepIndex,
                upcoming: idx > activeStepIndex,
              })
            }
          >
            <Box sx={{ display: "flex", flexDirection: "column", maxWidth: "240px" }}>
              <Typography
                sx={{
                  color: idx > activeStepIndex ? "#8995A9" : "#344054",
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "20px",
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  color: idx > activeStepIndex ? "#8796AB" : "#475467",
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                }}
              >
                {description}
              </Typography>
            </Box>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CreatePaymentLinkStepper;
